var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76954 0.816178C4.22326 1.26661 2.84864 2.17262 1.82502 3.41602C0.801389 4.65941 0.176283 6.18246 0.03125 7.78646H3.68839C3.90157 5.3456 4.60927 2.97366 5.76839 0.815035L5.76954 0.816178ZM3.68839 9.21504H0.03125C0.175981 10.8191 0.80082 12.3423 1.82425 13.5859C2.84767 14.8295 4.22216 15.7358 5.76839 16.1865C4.60927 14.0278 3.90157 11.6559 3.68839 9.21504ZM7.60154 16.4916C6.21591 14.294 5.36639 11.8014 5.12154 9.21504H10.8758C10.631 11.8014 9.78145 14.294 8.39582 16.4916C8.13122 16.5048 7.86613 16.5048 7.60154 16.4916ZM10.2301 16.1853C11.7762 15.7347 13.1505 14.8286 14.174 13.5852C15.1974 12.3418 15.8223 10.8189 15.9673 9.21504H12.3101C12.0969 11.6559 11.3892 14.0278 10.2301 16.1865V16.1853ZM12.3101 7.78646H15.9673C15.8225 6.1824 15.1977 4.65921 14.1743 3.4156C13.1508 2.172 11.7763 1.26573 10.2301 0.815035C11.3892 2.97366 12.0969 5.3456 12.3101 7.78646ZM7.60154 0.509892C7.86652 0.496703 8.13199 0.496703 8.39697 0.509892C9.78219 2.70759 10.6313 5.20017 10.8758 7.78646H5.12268C5.37068 5.18418 6.22211 2.68932 7.60154 0.509892Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.f9c01a67aa128bca2474eb4f4639c22c.svg";
export { ForwardRef as ReactComponent };